import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';

const SkeletonRow = styled.div<{ height: number }>`
  width: 100%;
  height: ${({ height }) => height}px;
  border-radius: 8px;
`;

export interface UDPagedListSkeletonProps {
  /** Сколько заглушек нарисовать: обычно это `perPage`. */
  count: number;
  /**
   * Раскладка заглушек — та же, что у самих элементов, иначе на первой загрузке
   * список «переезжает» из колонки в сетку.
   */
  className?: string;
  /** Высота одной заглушки: у строки и у карточки она разная. */
  rowHeight?: number;
}

const DEFAULT_ROW_HEIGHT = 72;

/**
 * Заглушка списка на **первую** загрузку. При поиске и смене страницы вместо неё
 * остаётся прошлый ответ, притушенный `UDAsyncContent` — иначе список схлопывался
 * бы на каждом нажатии клавиши.
 */
const UDPagedListSkeleton = ({
  count,
  className = 'flex flex-col gap-2.5',
  rowHeight = DEFAULT_ROW_HEIGHT,
}: UDPagedListSkeletonProps) => (
  // `self-start`: служебные ветки `UDAsyncContent` центрируют содержимое
  // (`flex-center`), а скелетон списка должен начинаться там же, где начнётся сам
  // список — у верхнего края, иначе он повисает в середине пустой области.
  <div className={classNames('w-full self-start', className)} data-testid="paged-list-skeleton">
    {Array.from({ length: count }, (_, index) => (
      <SkeletonRow className="skeleton-block" height={rowHeight} key={index} data-testid="paged-list-skeleton-row" />
    ))}
  </div>
);

export default UDPagedListSkeleton;
